import React from 'react';
import { View, Image, StyleSheet } from 'react-native';
// import SelectMultiple from 'react-native-select-multiple';

const MajmoehScreen = ({ navigation }) => {
    const fruits = ['Apples', 'Oranges', 'Pears']

    return (
        <View>
            {/* <SelectMultiple
                items={fruits}
                // selectedItems={this.state.selectedFruits}
                // onSelectionsChange={this.onSelectionsChange}
            /> */}
        </View>
    );
};

export default MajmoehScreen;

const styles = StyleSheet.create({
    logoStyles: {
        height: 45,
        width: 110,
    },
});
